import { render, staticRenderFns } from "./EducativeAdditionalInfo.vue?vue&type=template&id=1e8519ac&functional=true"
import script from "./EducativeAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./EducativeAdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e8519ac')) {
      api.createRecord('1e8519ac', component.options)
    } else {
      api.rerender('1e8519ac', component.options)
    }
    module.hot.accept("./EducativeAdditionalInfo.vue?vue&type=template&id=1e8519ac&functional=true", function () {
      api.rerender('1e8519ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/visits/EducativeAdditionalInfo.vue"
export default component.exports